// extracted by mini-css-extract-plugin
export default {"loader":"PubLoader_loader__gyRPh","matrix":"PubLoader_matrix__Cg0V3"};